import { websitePublicConfig } from '@/config/website-public';
import { defineRouting } from 'next-intl/routing';

export const DEFAULT_LOCALE = websitePublicConfig.i18n.defaultLocale;
export const LOCALES = Object.keys(websitePublicConfig.i18n.locales);

/**
 * Next.js internationalized routing
 *
 * https://next-intl.dev/docs/routing
 * https://github.com/amannn/next-intl/blob/main/examples/example-app-router/src/i18n/routing.ts
 */
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: LOCALES,
  // Default locale when no locale matches
  defaultLocale: DEFAULT_LOCALE,
  // Auto detect locale
  // https://next-intl.dev/docs/routing/middleware#locale-detection
  localeDetection: false,
  // The URL is the only public locale source. Do not let next-intl persist
  // or infer a locale from a cookie.
  localeCookie: false,
  // The prefix to use for the locale in the URL
  // https://next-intl.dev/docs/routing#locale-prefix
  localePrefix: 'as-needed',
});
